import React from 'react'
import teamImg1 from "../assets/Me (square).jpg";
import teamImg2 from "../assets/nina.jpg";
import skull from "../assets/eegg-apeskull-dirty.png";
import eegWorm from "../assets/eegg-worm.png";
import gem8Dirty from "../assets/eegg-gem8-dirty.png";
import eegDiamond from "../assets/eegg-diamondget-dirty.png";
import eegHodl from "../assets/eegg-hodl.png";
import Footer from './Footer';
import End from './End';
import { useMediaQuery } from 'react-responsive';





function Team() {
    const isMobile = useMediaQuery({ query: '(max-width: 667px)' })
  return (
    <div id="team_id" className='Team utilityBG mt-[-12px] ' >
        <div className=" flex justify-start m-6 mt-0 pb-56 mb-0 flex-wrap lg:ml-32  ">

            <div className="teamLeft text-left relative mr-5 p-[50px] lg:mr-10 lg:min-w-[50%] ">
            <img src={skull} className='absolute top-72 left-[-22px] w-20 lg:w-44 lg:left-[-92px]
             '
            alt="" />
                <img src={eegWorm} className='absolute bottom-[-25rem] right-34 lg:right-44 w-[80px] sm:w-[130px] '
            alt="" />
            <div className="teamLeftTitle text-[24px] text-white m-10 font-title lg:text-[45px] ml-[-30px] ">
                Team
            </div>
            <div className={`parent  ${isMobile?'grid grid-flow-row-dense grid-cols-3  gap-3 ':''}  `} >
            <div className={`teamImgWrapper my-5 lg:my-10 ${isMobile?' mt-auto mb-auto ':''}`}>
                <img src={teamImg1} className='w-24 rounded-full lg:w-48' alt="" />
            </div>
            <div className='col-span-2' >
            <div className="name  text-[15px] text-white font-title lg:text-[30px]">
                Josiah
            </div>
            <div className="email mt-1 text-[8px] mb-3 text-white font-early lg:text-[28px]">
                @themavrek
            </div>
            <div className="teamDesc font-[`Early GameBoy`] text-[7px] text-white font-early lg:text-[20px] ">
            Bachelor of Business graduate from RMIT in Melbourne, Australia. Has years of experience in the gaming industry, currently works at a Fortune 500 tech company. Head of development and marketing for Coin Plants NFT. Addicted to filter coffee.
            </div>
            </div>
            </div>
            
            </div>

            {/* right */}
          

            <div className="TeamRight text-left relative mx-auto w-full p-[50px] pb-[0px]
            lg:m-10 lg:mr-20 lg:min-w-[50%] lg:pr-20
            ">

            <img src={eegHodl} className='absolute bottom-[-10rem] right-[12rem] rotate-12 m-12
            w-[80px] sm:w-[130px]  lg:right-[7rem]' alt="" />
                <img src={eegDiamond} className='absolute bottom-[-9rem] right-22 w-[80px] sm:w-[130px] ' alt="" />
            <div className="mt-[1rem] ml-[8rem]
            w-[80px] sm:w-[130px] 
            lg:mt-[-3.7rem] ">
                <img src={gem8Dirty} alt="" />
            </div>
            <div className={`parent  ${isMobile?'grid grid-flow-row-dense grid-cols-3  gap-3 ':''}  `} >
            <div className={`teamImgWrapper my-10  ${isMobile?' mt-auto mb-auto ':''}`}>
                <img src={teamImg2} className='w-24 rounded-full lg:w-48' alt="" />
            </div>

            <div className='col-span-2'>
            <div className="name  text-[15px] text-white font-early lg:text-[30px]">
                Nina
            </div>
            <div className="email mt-1 text-[8px] mb-3 text-white font-early lg:text-[28px]">
                @ninastwenties
            </div>
            <div className="teamDesc font-[`Early GameBoy`] text-[7px] text-white font-early lg:text-[20px]">
            Passionate illustrator with a focus on pixel art. Writes for Medium in her spare time and currently studies Japanese. Spent weeks hand-crafting each pixel of Coin Plants with love. Owns the cutest cat known to mankind 
            </div>
            </div>
            

            </div>
                
            </div>
            
            
        </div>
        <End/>
        <Footer/>

    </div>
  )
}

export default Team